export default "/build/images/troy.4f5c8d13.png";